import { NAV_LINKS, LOGO_WHITE } from "../../data/content";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] px-6 md:px-10 pt-24 pb-10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto">
        {/* Oversized wordmark */}
        <div className="border-b border-white/10 pb-16">
          <img
            src={LOGO_WHITE}
            alt="OORU"
            className="w-full max-w-none h-auto opacity-90 select-none"
            style={{ maxHeight: "18vw" }}
          />
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="font-body text-neutral-400 leading-relaxed font-light max-w-sm">
              OORU is the original entertainment IP division founded by the team behind Cinimage
              Studios, building original stories for the mobile-first generation.
            </p>
            <a
              href="mailto:partner@ooru.co"
              data-testid="footer-email"
              className="mt-5 inline-block font-body text-white hover:text-[#ff8c00] transition-colors"
            >
              partner@ooru.co
            </a>
          </div>

          <div className="md:col-span-4 md:col-start-7">
            <span className="font-body text-xs uppercase tracking-[0.28em] text-neutral-600">
              Explore
            </span>
            <div className="mt-5 grid grid-cols-2 gap-3">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="font-body text-neutral-400 hover:text-white transition-colors"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <span className="font-body text-xs uppercase tracking-[0.28em] text-neutral-600">
              Social
            </span>
            <div className="mt-5 flex flex-col gap-3">
              {["LinkedIn", "Instagram", "X"].map((s) => (
                <a
                  key={s}
                  href="#top"
                  data-testid={`footer-social-${s.toLowerCase()}`}
                  className="font-body text-neutral-400 hover:text-white transition-colors"
                >
                  {s}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="font-body text-sm text-neutral-600">
            © {new Date().getFullYear()} OORU. All rights reserved.
          </p>
          <p className="font-body text-sm text-neutral-600">
            Built for the mobile-first generation.
          </p>
        </div>
      </div>
    </footer>
  );
};
